import store from "../store";

export const awardSelectors = {
	isFetching: (state = store.getState()) => state.award.isFetching,
	isRefresh: (state = store.getState()) => state.award.isRefresh,
	error: (state = store.getState()) => state.award.error,
	content: (state = store.getState()) => state.award.content,
	award: (state = store.getState()) => state.award.content.award,
	awardId: (state = store.getState()) => state.award.content.awardId,
	values: (state = store.getState()) => state.award.content.values,
	caseInstanceId: (state = store.getState()) => state.award.content.award.caseInstanceId,
	id: (state = store.getState()) => state.award.content.award.awardId,
};
